import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledCardBody = styled.div``

const CardBody = ({children, ...otherProps}) => <StyledCardBody {...otherProps}>{children}</StyledCardBody>

CardBody.propTypes = {
  children: PropTypes.any
}

export {CardBody}
